const qxList = {
  '339': {
    'audio': true,
    'stockLink': true,
  },// 浙商
  'xyzq': {
    'audio': true,
  },// 兴业
  '89': {
    'stockLink': true,
  },// 中原qsid
  'zyzq': {
    'stockLink': true,
  }// 中原scheme
};

const getFirstWordAfter = (text, keyword) => {
  const notFound = -1;
  const startIndex = text.indexOf(keyword);
  if (startIndex === notFound) {
    return '';
  }
  const targetText = text.slice(startIndex + keyword.length);
  const [value] = targetText.split(' ');
  return value || '';
};

export const getQsid = function () {
  const ua = navigator.userAgent;
  const qsid = getFirstWordAfter(ua, 'qsid/');
  return qsid || getFirstWordAfter(ua, 'scheme/');
};
export const getQX = function (type) {
  const qsid = getQsid();
  if (qxList[qsid]) {
    return qxList[qsid][type] || false;
  }
  return false;
};
